import Component from "@glimmer/component"
import styles from "./edit.module.css"

interface Args {
  screen: string
  prev: Function
  goToScreen: Function
}

export default class CreateEditFootersEditComponent extends Component<Args> {
  readonly styles = styles
}
